import { render, staticRenderFns } from "./FilterCriteria.vue?vue&type=template&id=271adf58&scoped=true&"
import script from "./FilterCriteria.vue?vue&type=script&lang=js&"
export * from "./FilterCriteria.vue?vue&type=script&lang=js&"
import style0 from "./FilterCriteria.vue?vue&type=style&index=0&id=271adf58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271adf58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('271adf58')) {
      api.createRecord('271adf58', component.options)
    } else {
      api.reload('271adf58', component.options)
    }
    module.hot.accept("./FilterCriteria.vue?vue&type=template&id=271adf58&scoped=true&", function () {
      api.rerender('271adf58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comparison/filter-criteria/FilterCriteria.vue"
export default component.exports